import { Divider, makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
    divider: {
        marginTop: '26px',
        marginBottom: '16px',
        color: tokens.colorNeutralForeground3,
        fontSize: tokens.fontSizeBase200,
        fontWeight: tokens.fontWeightBold,
        letterSpacing: '0.05em',
        textTransform: 'uppercase',
    },
    first: {
        marginTop: 0,
    },
});

interface SubSectionDividerProps {
    label: string;
    /** Drop the top margin when this is the first element in a section. */
    first?: boolean;
}

/** Uppercase label + hairline rule, for grouping fields within a section (§6.8). */
const SubSectionDivider = ({ label, first }: SubSectionDividerProps) => {
    const styles = useStyles();
    return (
        <Divider
            appearance="strong"
            alignContent="start"
            className={first ? `${styles.divider} ${styles.first}` : styles.divider}
        >
            {label}
        </Divider>
    );
};

export default SubSectionDivider;
